import { CookieBotHandleOnConsentReady } from "@ploy-ui/core";
import { useDispatch } from "@ploy-lib/calculation";

export function CookieBotSpecialHandling() {
	const dispatch = useDispatch();
	return (<CookieBotHandleOnConsentReady dispatch={dispatch} />);
}